module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_ SHIFTING EFFECT LEATHER _deskstop.54f9bc95.jpg";